
import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import PageObserver from "../Translation/PageObserver";
import FreeTierBanner from "../Plan/FreeTierBanner";

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className="flex min-h-screen flex-col hero-dark-gradient">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 px-3 py-2 self-start m-2 rounded text-on-hero"
      >
        Hoppa till innehåll
      </a>
      <Header />
      <main id="main" className="flex-1">
        <div className="container mx-auto px-4">
          <FreeTierBanner />
        </div>
        {children}
      </main>
      <footer className="border-t border-white/10 px-4 py-6 text-xs text-on-hero/60">
        <div className="container mx-auto flex flex-wrap items-center justify-between gap-3">
          <span>© {new Date().getFullYear()} Byggarbetsmiljökontrollen</span>
          <nav className="flex flex-wrap gap-4">
            <Link to="/villkor" className="hover:text-on-hero">
              Användarvillkor
            </Link>
            <Link to="/integritetspolicy" className="hover:text-on-hero">
              Integritetspolicy
            </Link>
            <Link to="/verifiera" className="hover:text-on-hero">
              Verifiera dokument
            </Link>
          </nav>
        </div>
      </footer>
      {/* PageObserver is now used inside MainLayout which is always within Router */}
      <PageObserver />
    </div>
  );
};

export default MainLayout;
